/** Rutas de Hotelería/campamento: requieren proyecto real (no Corporativo). */
export const HOTELERIA_ROUTE_PREFIXES = [
  '/procesos/hoteleria/',
  '/mantenimientos/hoteleria/',
  '/reportes/hoteleria/',
  '/consultas/hoteleria/',
];

export const isCorporativoProject = (project) =>
  project?.tipo === 'corporativo' ||
  project?.id === -1 ||
  project?.id === '-1';

export const isHoteleriaRoute = (pathname) =>
  HOTELERIA_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));

/** Rutas RRHH accesibles en contexto corporativo (catálogos y operaciones por proyecto). */
export const RRHH_ROUTE_PREFIX = '/rrhh';

export const CORPORATIVO_ALLOWED_PATHS = [
  '/resumen-corporativo',
  '/depositos',
  '/corporativo/depositos',
  '/corporativo/eliminar-depositos',
  '/corporativo/centros-costo',
  '/corporativo/tipos-deposito',
  '/corporativo/proveedores',
  '/corporativo/beneficiarios',
  '/corporativo/bancos',
  '/corporativo/metodos-pago',
  '/corporativo/clientes-facturacion',
  '/corporativo/facturas-venta',
  '/reportes/corporativo/depositos',
  '/corporativo/seguridad/usuarios',
  '/corporativo/seguridad/roles',
  '/corporativo/seguridad/permisos-roles',
  '/corporativo/seguridad/menus-roles',
  '/corporativo/seguridad/usuarios-roles',
  '/consultas/generales/dni-reniec',
  RRHH_ROUTE_PREFIX,
];

/** Ocultar ítems de menú Hotelería cuando el contexto es Corporativo. */
export const filterMenuForCorporativo = (categories) => {
  if (!categories?.length) return categories;

  const filterItems = (items) => {
    if (!items?.length) return items;
    return items
      .map((item) => {
        if (item.items?.length) {
          const sub = filterItems(item.items);
          if (!sub?.length) return null;
          return { ...item, items: sub };
        }
        if (
          item.path &&
          HOTELERIA_ROUTE_PREFIXES.some((p) => item.path.startsWith(p))
        ) {
          return null;
        }
        return item;
      })
      .filter(Boolean);
  };

  return categories
    .map((cat) => {
      if (!cat.items?.length) return cat;
      const items = filterItems(cat.items);
      if (!items?.length) return null;
      return { ...cat, items };
    })
    .filter(Boolean);
};
